import { WallSide } from '../enums/wallSide.enum';
import { DoorType } from '../enums/doorType.enum';
import { DoorDirection } from '../enums/doorDirection.enum';
import { DoorModel } from './doorModel';
import { FinishTypes } from '../enums/finishTypes.enum';
import { HingeType } from '../enums/hingeType.enum';
import { DoorHandleType } from '../enums/doorHandleType.enum';

export class DoorPosition {
  id: number;
  doorModel: DoorModel;
  left: number;
  side: WallSide;
  frameInteriorFinish: FinishTypes;
  frameExteriorFinish: FinishTypes;
  selected: boolean;
  mesh?: any;
  image = 'assets/svg/close.svg';
  panelHeight: number;
  salesPrice: false | number;
  hingeType?: HingeType;
  doorHandleType?: DoorHandleType;
  innerWallId?: string;
  backPanelMaterial: string;
  frontPanelMaterial: string;
  leafInteriorFinish: FinishTypes = FinishTypes.STEEL;
  leafExteriorFinish: FinishTypes = FinishTypes.STEEL;

  constructor(
    id: number,
    left: number,
    side: WallSide,
    openingWidth: number,
    openingHeight: number,
    panelWidth: number,
    panelHeight: number,
    frameInteriorFinish: FinishTypes,
    frameExteriorFinish: FinishTypes,
    leafInteriorFinish?: FinishTypes,
    leafExteriorFinish?: FinishTypes,
    type?: DoorType,
    direction?: DoorDirection,
    hingeType?: HingeType,
    doorHandleType?: DoorHandleType,
    innerWallId?: string
  ) {
    this.id = id;
    this.doorModel = null;
    this.doorModel = new DoorModel(type, openingWidth, openingHeight, panelWidth, panelHeight, direction);
    this.left = left !== undefined ? left : 300;
    this.side = side !== undefined ? side : WallSide.south;
    this.panelHeight = panelHeight;
    this.frameExteriorFinish = frameExteriorFinish;
    this.frameInteriorFinish = frameInteriorFinish;
    this.setLeafExteriorFinish(leafExteriorFinish || FinishTypes.STEEL);
    this.setLeafInteriorFinish(leafInteriorFinish || FinishTypes.STEEL);
    this.hingeType = hingeType || HingeType.normal;
    this.doorHandleType = doorHandleType || DoorHandleType.euro2015;
    this.innerWallId = innerWallId;
  }

  get direction(): number {
    return this.doorModel.direction;
  }

  set direction(value: number) {
    this.doorModel.direction = value;
  }

  setLeafInteriorFinish(value: FinishTypes) {
    this.leafInteriorFinish = value;
    this.backPanelMaterial = this.materialFromFinishType(value);
  }

  setLeafExteriorFinish(value: FinishTypes) {
    this.leafExteriorFinish = value;
    this.frontPanelMaterial = this.materialFromFinishType(value);
  }

  materialFromFinishType(finishType: FinishTypes): string {
    switch (finishType) {
      case FinishTypes.STEEL:
      case FinishTypes.STEEL_PET55:
        return '#FFFFFF';
      case FinishTypes.RVS304_ROUND_BRUSH:
      case FinishTypes.RVS316_ROUND_BRUSH:
        return 'rvs-circular';
      case FinishTypes.RVS304_DESIGN_5WL:
      case FinishTypes.RVS304_LINEN:
        return 'rvs-plate';
      case FinishTypes.RVS304_COLLED_ROLLED:
      case FinishTypes.RVS304_LINE_BRUSH:
        return 'rvs';
    }
  }

  equals(door: DoorPosition) {
    return door ? this.left === door.left && this.side === door.side : false;
  }

  clone(): DoorPosition {
    const clone = new DoorPosition(
      this.id,
      this.left,
      this.side,
      this.doorModel.openingWidth,
      this.doorModel.openingHeight,
      this.doorModel.panelWidth,
      this.doorModel.panelHeight,
      this.frameInteriorFinish,
      this.frameExteriorFinish,
      this.leafInteriorFinish,
      this.leafExteriorFinish,
      this.doorModel.type,
      this.doorModel.direction,
      this.hingeType,
      this.doorHandleType,
      this.innerWallId
    );
    return clone;
  }
}
